import { Component, OnInit,Inject} from '@angular/core';
import { NgModel } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatSnackBar,
} from '@angular/material/snack-bar';
import { CustomCodeService } from './custom-code.service';


@Component({
  selector: 'app-custom-code',
  templateUrl: './custom-code.component.html',
  styleUrls: ['./custom-code.component.css']
})

export class CustomCodeComponent implements OnInit {
  isActive: boolean = true;
  selectedCustomCode = '';
  
  get isInclusionType(): boolean {
    return this.customCodes?.type === 'INCLUDE';
  }
  
  get listTypeLabel(): string {
    return this.isInclusionType ? 'Inclusions' : 'Exclusions';
  }
  
  get listTypeLabelSingular(): string {
    return this.isInclusionType ? 'Inclusion' : 'Exclusion';
  }
  
  get currentList(): any {
    return this.isInclusionType ? this.customCodes?.inclusion_list : this.customCodes?.exclusion_list;
  }

  constructor(private _snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, private _matDialog: MatDialog, private customCodeService: CustomCodeService, private _location: Location, private router: Router){
  }
  ngOnInit(): void {
    this.selectedCustomCode = this.activatedRoute.snapshot.params.customCode;
    this.getCustomCodes();
  }
  customCodes: any ;
  getCustomCodes(){
    this.customCodeService.getCustomCodes(this.selectedCustomCode).subscribe(
      (response) => {
        this.customCodes = response.body;
        if(this.customCodes.authentication === null){
          this.isActive = false;
        }
        this.getCustomCodeLink(this.selectedCustomCode)
      },
      (error) => {
        console.error(error);
      }
    );
  }
  getArrayLength(key: any): any {
    const currentList = this.isInclusionType ? this.customCodes.inclusion_list : this.customCodes.exclusion_list;
    return currentList[key]?.length || 0;
  }
  backClicked() {
    this.router.navigate([`/custom-code`]);
  }
  customCodeLink: any;
  getCustomCodeLink(customCode: any){
    this.customCodeService.getCustomCodeLink(customCode).subscribe(
      (response) => {
        this.customCodeLink = response.body
      },
      (error) => {
        console.error('Error fetching custom codes:', error);
      }
    );
  }
  goTo(){
    if(this.isActive){
      this.router.navigate([`/custom-code/authentication-native/${this.selectedCustomCode}`]);
    }
    else{
      this.router.navigate([`/custom-code/authentication/${this.selectedCustomCode}`]);
    }
  }
  

  exclusionComponent(){
    const dialogRef = this._matDialog.open(exclusionComponentDialog, {
      data: {
        exclusion: this.currentList,
        isInclusionType: this.isInclusionType,
        listTypeLabel: this.listTypeLabel
      }
  });
  }

  copiedMessage = 'Copied to Clipboard';
  codeCopied = false
  linkCopied = false
  copyMessage(inputText: any,option: string){
  const tempInput = document.createElement('textarea');
  tempInput.value = inputText;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand('copy');
  document.body.removeChild(tempInput);
  navigator.clipboard.writeText(inputText)

    if(option === 'code'){
      this. codeCopied = true;
      setTimeout(() => {
         this. codeCopied = false;
      },1000)
    }
    else if(option === 'link'){
      this.linkCopied = true;
      setTimeout(() => {
         this.linkCopied = false;
      },1000)
    }
  }
}

@Component({
  selector: 'app-exclusions',
  templateUrl: './exclusions.html',
  styleUrls: ['./custom-code.component.css']
})
export class exclusionComponentDialog{
  
  exclusions: any;
  isInclusionType: boolean;
  listTypeLabel: string;
  
  constructor(public dialogRef: MatDialogRef<exclusionComponentDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private _snackBar: MatSnackBar, private _dialog: MatDialog) {
    this.exclusions = data.exclusion;
    this.isInclusionType = data.isInclusionType;
    this.listTypeLabel = data.listTypeLabel;
  }
  closePopUp(){
    this.dialogRef.close();
  }
  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // RaiseRequestComponent(){
  //   this._dialog.open(RaiseRequestDialog,{

  //   });
  // }
}

// @Component({
//   selector: 'app-raise-request',
//   templateUrl: './raise-request.html',
//   styleUrls: ['./custom.code.component.css']
// })

// export class RaiseRequestDialog{
//   constructor(public dialogRef: MatDialogRef<RaiseRequestDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private _snackBar: MatSnackBar) {
//   }
//   closePopUp(){
//     this.dialogRef.close();
//   }
//   comment: string = ''; 
//   wordCount: number = 0;
//   updateWordCount() {
//     const words = this.comment.trim().split(/\s+/).filter(word => word !== '');
//     this.wordCount = words.length;
//   }
//   items = [
//     { name: "Rewards", checked: false },
//     { name: "Skill Corner", checked: false },
//     { name: "Movies and Cartoon", checked: false },
//     { name: "Phone Number", checked: false }
//   ];
//   checkedItems: string[] = ["Rewards", "Skill Corner"];
//   open: boolean = false;
//   handleCheckboxChange(event: any) {
//     const { id, checked } = event.target;
//     if (checked) {
//       this.checkedItems = [...this.checkedItems, id];
//     } else {
//       this.checkedItems = this.checkedItems.filter(item => item !== id);
//     }
//   }
  
//   handleRemoveItem(itemToRemove: string) {
//     this.checkedItems = this.checkedItems.filter(item => item !== itemToRemove);
//   }
  
// }


